import request from '../util/http'

//查询地区所属担保机构
export function queryChanelByPcd(data) {
  return request({
    url: '/zcjf/biz/guarantee/channel/queryChanelByPcd',
    method: 'post',
    data,
  })
}

//查询地区所属保险机构
export function queryInsuranceChanelByPcd(params) {
  return request({
    url: '/zcjf/biz/guarantee/channel/queryInsuranceChanelByPcd',
    method: 'get',
    params,
  })
}


export function queryHbOrderInfo(str) {
  return request({
    url: '/zcjf/biz/guarantee/order/queryHbOrderInfo',
    method: 'post',
    data: {
      projectStr: str,
      querySource: 'zcjf',
    },
  })
}

export function calculateInsurance(params) {
  return request({
    url: '/zcjf/biz/guarantee/insurance/calculateInsurance',
    method: 'get',
    params,
  })
}

export function queryBankByProvince(params) {
  return request({
    url: '/zcjf/biz/guarantee/bank/queryBankByProvince',
    method: 'get',
    params,
  })
}

//银行保函提交

export const submitBank = (data) =>
  request({
    url: '/zcjf/biz/guarantee/bank/submitBank',
    method: 'post',
    data,
  })
export function signOrder(params) {
  return request({
    url: '/zcjf/biz/guarantee/order/signOrder',
    method: 'get',
    params,
  })
}
//担保保函提交
export const submitElectronic = (data) =>
  request({
    url: '/zcjf/biz/guarantee/electronic/submitElectronic',
    method: 'post',
    data,
  })
//保险保函提交
export const confirmInsurance = (data) =>
  request({
    url: '/zcjf/biz/guarantee/insurance/confirmInsurance',
    method: 'post',
    data,
  })

//校验是否需要签订承诺书
export const checkCommitment = (data) =>
  request({
    url: '/zcjf/biz/guarantee/electronic/checkCommitment',
    method: 'post',
    data,
  })

//预览签订承诺书
export function commitmentSign(params) {
  return request({
    url: '/zcjf/biz/guarantee/electronic/commitmentSign',
    method: 'get',
    params,
  })
}

// 判断是否线上支付
export function commitmentScendCallback(id) {
  return request({
    url: '/zcjf/biz/guarantee/electronic/commitmentScendCallback',
    method: 'get',
    params: {
      orderId: id,
    },
  })
}

export function submitCommitmentSign(params) {
  return request({
    url: '/zcjf/biz/guarantee/electronic/submitCommitmentSign',
    method: 'get',
    params,
  })
}
// 履约保函提交
export const submitPerformance = (data) =>
  request({
    url: '/zcjf/biz/guarantee/performance/submitPerformance',
    method: 'post',
    data,
  })

export const getDockingPlatformInfoByOrderId = (param) =>
  request({
    url: '/zcjf/biz/guarantee/bfeDockingPlatform/getDockingPlatformInfoByOrderId',
    method: 'get',
    params: {
      orderId: param
    },
  })
//查询邢台保函项目信息
export const queryXtOrderInfo = (data) =>
  request({
    url: '/zcjf/biz/guarantee/oti/queryXtOrderInfo',
    method: 'post',
    data
  })

//查询字典
export const querySysValueData = (params) => {
  return request({
    url: '/zcjf/biz/sys/opt/querySysValueData',
    method: 'get',
    params
  })
}

//查询字典
export const querySysValueDataList = (params) => {
  return request({
    url: '/zcjf/biz/sys/opt/querySysValueDataList',
    method: 'get',
    params
  })
}

//查询配置
export const queryBaseConfig = (params) => {
  return request({
    url: '/zcjf/base/config/detail',
    method: 'get',
    params
  })
}

//查看是否为机构打款
export const queryPartnerRegionByPartnerId = (param) =>{
  return request({
    url: '/zcjf/biz/guarantee/channel/queryPartnerRegionByPartnerId',
    method: 'post',
    params: param
  })
  }


//查询保函支付方式
export const queryModePayment = (param) =>{
  return request({
    url: '/zcjf/biz/guarantee/channel/queryModePayment',
    method: 'post',
    params: param
  })
  }

  //查询对接平台相关信息
export const queryApiConfigInfo = (param) =>{
  return request({
    url: '/zcjf/biz/guarantee/channel/queryApiConfigInfo',
    method: 'post',
    params: param
  })
  }

//生成保函申请书
export const createGuaranteeApply = (data) =>
  request({
    url: '/zcjf/biz/guarantee/electronic/createGuaranteeApply',
    method: 'post',
    data,
  })

//获取电子签章地址
export const getEelecSignUrl = (params) =>
  request({
    url: '/zcjf/biz/guarantee/hsyh/getEelecSignUrl',
    method: 'post',
    params,
  })

//获取跳转vipUrl
export const jumpVipUrl = (params) =>
  request({
    url: '/zcjf/base/vipCenter/jumpVipSystem',
    method: 'post',
    params,
  })

// 查看文本详情
export const getContentDetailByType = (params) =>
  request({
    url: '/zcjf/base/content/detailByType',
    method: 'get',
    params,
  })

//查询数据字典
export const queryDefaultDataDictionary = (params) =>
  request({
    url: '/zcjf/data/dataForms/queryDefaultDataDictionary',
    method: 'get',
    params,
  })

// 查询项目信息
export function pageQueryBidProject(params) {
  return request({
    url: '/zcjf/data/dataForms/pageQueryBidProject',
    method: 'get',
    params
  })
}

export function pageQueryGuaranteeProject(params) {
  return request({
    url: '/zcjf/data/dataForms/pageQueryGuaranteeProject',
    method: 'get',
    params
  })
}

// ========== 保函申请草稿 ==========

/**
 * 保存保函申请草稿
 * @param body { orderType, outerOrderNo?, step, formData }
 */
export function saveGuaranteeDraft(body) {
  return request({
    url: '/zcjf/biz/guarantee/draft/saveDraft',
    method: 'post',
    data: body
  })
}

/**
 * 查询保函申请草稿
 * @param params { orderType, outerOrderNo? }
 */
export function queryGuaranteeDraft(params) {
  return request({
    url: '/zcjf/biz/guarantee/draft/queryDraft',
    method: 'get',
    params
  })
}

/**
 * 清空保函申请草稿
 */
export function clearGuaranteeDraft(body) {
  return request({
    url: '/zcjf/biz/guarantee/draft/clearDraft',
    method: 'post',
    data: body
  })
}